import {getAwpClientHeaders} from '../../session/awpRequestHeaders';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

/**
 * Search Wikidata properties by label (or P-ID).
 *
 * @param {string} query
 * @param {number} [limit=20]
 * @returns {Promise<{results: Array<{propertyId: string, propertyLabel: string, description?: string, source?: string}>, wikidataRemoteEnabled: boolean, searchedRemote: boolean}>}
 */
export async function searchWikidataProperties(query, limit = 20) {
    const q = (query || '').trim();
    if (q.length < 2) {
        return {results: [], wikidataRemoteEnabled: true, searchedRemote: false};
    }

    const url = new URL(`${BASE}/api/wikidata/properties/search`);
    url.searchParams.set('q', q);
    url.searchParams.set('limit', String(limit));

    const res = await fetch(url.toString(), {headers: getAwpClientHeaders()});
    if (!res.ok) {
        throw new Error(`Property search failed: HTTP ${res.status}`);
    }
    const json = await res.json();
    return {
        results: Array.isArray(json.results) ? json.results : [],
        wikidataRemoteEnabled: json.wikidataRemoteEnabled !== false,
        searchedRemote: json.searchedRemote === true,
    };
}
